var _polygon, _rect, _polygon2, _path, _path2, _path3, _path4, _path5, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "3.438,13.841 1.977,13.841 1.977,21.196 7.071,21.196 7.071,19.947 3.438,19.947  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.803,
    y: 13.78,
    width: 1.461,
    height: 7.416
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.082,19.269 11.25,13.78 9.666,13.78 12.252,21.196 13.812,21.196 16.403,13.78 14.854,13.78  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166,11.798c0.364-0.47,0.59-1.052,0.59-1.691c0-1.532-1.244-2.777-2.777-2.777c-1.534,0-2.777,1.245-2.777,2.777 c0,0.64,0.225,1.222,0.587,1.691H14.166z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.224,11.778C3.776,9.2,4.532,6.456,6.523,4.465c0.407-0.407,0.407-1.066,0-1.473s-1.067-0.407-1.473,0 c-2.397,2.396-3.373,5.668-2.944,8.785H4.224z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.739,11.778h2.117c0.429-3.117-0.547-6.389-2.945-8.785c-0.406-0.407-1.065-0.407-1.473,0 c-0.406,0.407-0.406,1.065,0,1.473C19.43,6.456,20.185,9.2,19.739,11.778z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.571,7.458c0.406-0.407,0.406-1.066,0-1.473c-0.407-0.406-1.067-0.406-1.474,0C5.523,7.56,5.015,9.763,5.505,11.778 h2.147C7.1,10.326,7.4,8.627,8.571,7.458z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.623,11.778c0.492-2.015-0.017-4.218-1.593-5.793c-0.407-0.406-1.066-0.406-1.473,0c-0.407,0.407-0.407,1.066,0,1.473 c1.172,1.17,1.471,2.868,0.919,4.32H18.623z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.022,21.196 21.917,21.196 21.917,19.947 18.484,19.947 18.484,17.929 21.917,17.929 21.917,16.679  18.484,16.679 18.484,15.035 21.917,15.035 21.917,13.78 17.022,13.78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.f27274f41e70f41ac5a4f3ca71109526.svg";
export { ForwardRef as ReactComponent };